import { ArrowLeftOutlined, BankOutlined } from "@ant-design/icons";
import {
  Avatar,
  Card,
  Empty,
  PageHeader,
  Skeleton,
  Tabs,
  Typography,
} from "antd";
import moment from "moment";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { connect } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import Empty_State from "../../Assets/empty_state.png";
import { translation } from "../../i18n/translationConstant";
import FIPModel from "../../Models/FIPModel";
import { GetFIPRequest } from "../../Models/Request/FIP/GetAllFIP";
import { getFips } from "../../Services/FipServices/FipServices";
import {
  getAllUserActivity,
  getUserSpecificActivity,
} from "../../Services/UserActivityServices/UserActivity";
import { defaultPageSize } from "../../Utils/Constants/apiConstants";
import { ConsentStatusType } from "../../Utils/Constants/consentTypes";
import { QueryParams, Routes } from "../../Utils/Constants/routes";
import useINF from "../Common/Components/InfiniteScroll";
import CommonLayout from "../More/CommonLayout";
import "./index.css";

interface IUserActivityProps {
  isLoading: boolean;
}
const UserActivity: React.FC<IUserActivityProps> = ({ isLoading }) => {
  const { t } = useTranslation();
  const [userActivity, setUserActivity] = useState<any>([]);
  const [fip, setFIP] = useState<GetFIPRequest>([]);
  const pageSize = defaultPageSize;
  const [page, setPage] = useState(1);
  const [key, setKey] = useState("1");
  const history = useHistory();

  const [hasMore, setHasMore] = useState(true);

  const observer = useRef<any>();

  const { newObserver, ref } = useINF(observer, hasMore, setPage);

  observer.current = newObserver.current;

  const useQuery = () => {
    const { search } = useLocation();

    return React.useMemo(() => new URLSearchParams(search), [search]);
  };
  const query: any = useQuery();

  useEffect(() => {
    getFips()
      .then((res1) => res1.data)
      .then((res1: GetFIPRequest) => {
        setFIP(res1);
      });
  }, []);

  const getUserActivity = useCallback(() => {
    if (query.get(QueryParams.entityType)) {
      getUserSpecificActivity(
        page - 1,
        pageSize,
        query.get(QueryParams.entityId),
        query.get(QueryParams.entityType),
        query.get(QueryParams.fipId) ? query.get(QueryParams.fipId) : null
      )
        .then((res) => res.data)
        .then((res) => {
          setHasMore(!res.last);
          setUserActivity((old: any) => old.concat(res.content));
        });
    } else {
      getAllUserActivity(
        page - 1,
        pageSize,
        key === "2" ? "/consent" : key === "3" ? "/account" : ""
      )
        .then((res) => res.data)
        .then((res) => {
          setHasMore(!res.last);

          setUserActivity((old: any) => old.concat(res.content));
        });
    }
  }, [page, pageSize, query, key]);

  useEffect(() => {
    getUserActivity();
  }, [getUserActivity]);

  const activityTitle = (type: string, jsonString: string) => {
    const json = JSON.parse(jsonString);

    switch (type) {
      case "AA_UPDATE_CONSENT_APPROVAL_STATUS":
      case "AA_UPDATE_CONSENT_APPROVAL_STATUS_ACCOUNT":
        return (
          <Typography.Text className="font14 fontWeight600">
            {json.constentApprovalStatus ===
              (localStorage.getItem("isV1") === "true" ? "READY" : "APPROVED")
              ? t(translation.lblConsentApproved)
              : t(translation.lblConsentRejected)}{" "}
          </Typography.Text>
        );

      case "AA_UPDATE_CONSENT_STATUS":
      case "AA_UPDATE_CONSENT_STATUS_ACCOUNT":
        return (
          <Typography className="font14 fontWeight600">
            {json.consentStatusType === ConsentStatusType.ACTIVE ? (
              t(translation.lblConsentApproved)
            ) : (
              <Typography.Text className="font14 fontWeight600">
                {t(type) + " " + json.consentStatusType}
              </Typography.Text>
            )}
          </Typography>
        );

      case "AA_STORE_CREATE_CONSENT_REQUEST":
        return (
          <Typography.Text className="font14 fontWeight600">
            {t(type)} by {json.fiu?.name}
          </Typography.Text>
        );
      case "AA_STORE_ACCOUNT_LINK_UPDATE":
        return (
          <>
            <Typography.Text className="font14 fontWeight600">
              {t(translation.account) +
                " " +
                json.accountStatusType +
                " " +
                t(translation.success)}
            </Typography.Text>
          </>
        );
      case "AA_FIP_ACCOUNT_DISCOVERY":
        return (
          <Typography className="font14 fontWeight600">{t(type)}</Typography>
        );

      case "ACCOUNT_DELINK":
        return (
          <Typography.Text className="font14 fontWeight600">
            {t(type)}
          </Typography.Text>
        );
      case "AA_STORE_SAVE_FI_REQUEST":
      case "AA_STORE_SAVE_FI_REQUEST_ACCOUNT":
        return (
          <Typography.Text className="font14 fontWeight600">
            {t(type)}
          </Typography.Text>
        );
      case "AA_PURGE_FI_DATA_FETCHED":
      case "AA_PURGE_FI_DATA_FETCHED_ACCOUNT":
      case "AA_PURGE_FI_DATA_EXPIRE":
      case "AA_PURGE_FI_DATA_EXPIRE_ACCOUNT":
        return (
          <Typography.Text className="font14 fontWeight600">
            Data has been purged
          </Typography.Text>
        );
      default:
        return null;
    }
  };

  const getID = (type: string, jsonString: string) => {
    const json = JSON.parse(jsonString);

    const { Text } = Typography;

    switch (type) {
      case "ACCOUNT_DELINK":
        return (
          <>
            {json.linkRefNumber && (
              <div className="row">
                <Text className="font12 fontWeight600">
                  {t("Transaction ID : ")}
                </Text>
                <Text className="font12 ">{json.linkRefNumber}</Text>
              </div>
            )}
          </>
        );

      case "AA_UPDATE_CONSENT_APPROVAL_STATUS":
        return (
          <>
            {json.consentHandle && (
              <div className="row">
                <Text className="font12 fontWeight600">
                  {t("Transaction ID : ")}
                </Text>
                <Text className="font12 ">{json.consentHandle}</Text>
              </div>
            )}
          </>
        );

      case "AA_UPDATE_CONSENT_STATUS":
      case "AA_STORE_CREATE_CONSENT_REQUEST":
        return (
          <>
            {json.transactionId && (
              <div className="userActivityDescripitionItems">
                <Text className="font12 fontWeight600">
                  {t("Transaction ID : ")}
                </Text>
                <Text className="font12 ">{json.transactionId}</Text>
              </div>
            )}
          </>
        );
      case "AA_STORE_ACCOUNT_LINK_UPDATE":
      case "AA_FIP_ACCOUNT_LINKING_INITIATE":
      case "AA_FIP_ACCOUNT_DISCOVERY":
        return (
          <>
            {json.txnid && (
              <div className="userActivityDescripitionItems">
                <Text className="font12 fontWeight600">
                  {t("Transaction ID : ")}
                </Text>

                <Text className="font12 ">{json.txnid}</Text>
              </div>
            )}
          </>
        );

      case "AA_STORE_SAVE_FI_REQUEST":
        return (
          <>
            {json.transactionId && (
              <div className="userActivityDescripitionItems">
                <Text className="font12 fontWeight600">
                  {t("Transaction ID : ")}
                </Text>
                <Text className="font12 ">{json.transactionId}</Text>
              </div>
            )}
          </>
        );
      default:
        return null;
    }
  };
  const getfip = (type: string, jsonString: string) => {
    const json = JSON.parse(jsonString);

    switch (type) {
      case "AA_UPDATE_CONSENT_APPROVAL_STATUS":
        return (
          <>
            {json.accounts && json.accounts[0] && (
              <div className="row">
                <Typography.Text className="font12 fontWeight600">
                  {"FIP : "}
                </Typography.Text>
                <Typography.Text className="font12 ">
                  {json.accounts[0]?.fipHandle}
                </Typography.Text>
              </div>
            )}
          </>
        );

      case "AA_UPDATE_CONSENT_STATUS":
      case "AA_STORE_CREATE_CONSENT_REQUEST":
        return (
          <>
            {json.fiu && (
              <div className="row">
                <Typography.Text className="font12 fontWeight600">
                  {"FIU : "}
                </Typography.Text>
                <Typography.Text className="font12 ">
                  {json.fiu?.name}
                </Typography.Text>
              </div>
            )}
          </>
        );
      case "AA_FIP_ACCOUNT_LINKING_INITIATE":
      case "ACCOUNT_DELINK":
      case "AA_STORE_ACCOUNT_LINK_UPDATE":
      case "AA_FIP_ACCOUNT_DISCOVERY":
        return (
          <>
            {json.fip && (
              <div className="row">
                <Typography.Text className="font12 fontWeight600">
                  {"FIP : "}
                </Typography.Text>
                <Typography.Text className="font12 ">
                  {json.fip?.name}
                </Typography.Text>
              </div>
            )}
          </>
        );

      case "AA_STORE_SAVE_FI_REQUEST":
        return <></>;
      default:
        return null;
    }
  };

  const retrieveAuditBasedOnKey = (activekey: string) => {
    setPage(1);
    setKey(activekey);
    setUserActivity([]);
    setHasMore(true);
  };

  const timeLineRender = () => {
    return userActivity.length !== 0 ? (
      <>
        {userActivity.map((activity: any, index: number) => (
          <Card key={index} className="cardStyles  ">
            <Skeleton loading={isLoading} avatar={true}>
              <div className="row spaceBetween">
                <div className="row flex40">
                  <div className="avatarBG">
                    <Avatar
                      className="activityAvatar"
                      src={
                        (fip.length !== 0 &&
                          fip.filter(
                            (FIP: FIPModel) =>
                              FIP.name ===
                              JSON.parse(activity.activityJson)?.fip?.name
                          )[0]?.logoUrl) ||
                        JSON.parse(activity.activityJson)?.fiu?.logoUrl
                      }
                      icon={<BankOutlined />}
                    />
                  </div>
                  <div className="col marginleft16">
                    {activityTitle(
                      activity.activityType,
                      activity.activityJson
                    )}
                    {getfip(activity.activityType, activity.activityJson)}
                  </div>
                </div>
                <div className="row spaceBetween flex60">
                  {getID(activity.activityType, activity.activityJson)}
                  <div>
                    <Typography.Text className="fontWeight600 font12">
                      {moment(activity.time).format("DD MMMM YYYY") +
                        " | " +
                        moment(activity.time).format("LT")}
                    </Typography.Text>
                  </div>
                </div>
              </div>
            </Skeleton>
          </Card>
        ))}
        <div className="infiniteDiv" ref={ref} />
      </>
    ) : (
      <Empty
        image={Empty_State}
        description={
          <Typography.Text className="consentErrorMsg">
            {t(translation.lblNoRecentActivities)}
          </Typography.Text>
        }
      />
    );
  };

  const goBack = () => {
    history.goBack();
  };

  const { TabPane } = Tabs;

  return (
    <>
      <CommonLayout>
        <div className="col width100 historyRoot">
          <PageHeader
            className="linkAccountTitle"
            backIcon={<ArrowLeftOutlined className="backIcon" onPointerOverCapture={undefined} onPointerMoveCapture={undefined} />}
            onBack={goBack}
            title={t(translation.lblHistory)}
          />
          {/* <Typography.Text className="font24 fontWeight600" style={{paddingLeft: '20px'}}>
          {t("lblHistory")}
        </Typography.Text> */}
          {query.get(QueryParams.entityType) ? (
            <div key="1" className="historyDiv width90">
              {timeLineRender()}
            </div>
          ) : (
            <Tabs
              onChange={retrieveAuditBasedOnKey}
              animated={true}
              defaultActiveKey="1"
              className="historyTab width90"
            >
              {["1", "2", "3"].map((keyLocal) => (
                <TabPane
                  tab={
                    keyLocal === "1"
                      ? t(translation.lblGeneral)
                      : keyLocal === "2"
                        ? t(translation.lblConsent)
                        : t(translation.lblAccounts)
                  }
                  key={keyLocal}
                >
                  {key === keyLocal ? timeLineRender() : <></>}
                </TabPane>
              ))}
            </Tabs>
          )}
        </div>
      </CommonLayout>
    </>
  );
};

const mapStateToProps = (state: any) => ({
  fip: state.fip.fips,
  isLoading: state.loader.searchLoader,
});

export default connect(mapStateToProps)(UserActivity);
